import styled from 'styled-components';

export const InputContainer = styled.div<any>`
  margin: 24px 0;

  ${(props) => props.isNested && `border-left: 1px solid #C4C4C4;padding-left: 20px;`}

  input:-webkit-autofill {
    -webkit-background-clip: text;
  }

  input:-webkit-autofill::first-line {
    font-size: 16px;
  }
`;

export const InputLabel = styled.label<any>`
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
  color: #2d3540;

  ${(props) =>
    props.newUi &&
    `
    font-family: var(--secondary-font-rebrand);
    color: var(--color-indigo-t11);
  `}
  ${(props) =>
    props.error &&
    `
    color: var(--color-coral-rb);
  `}

  span {
    font-weight: 400;
  }
`;

export const InputError = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #fa5245;
  display: block;

  a {
    color: #fa5245;
    text-decoration: underline;
    font-weight: 700;
  }

  button {
    color: #fa5245;
    font-weight: 700;
    text-decoration: underline;
    font-weight: 700;
    background: transparent;
    outline: none;
  }
`;

export const ChildrenContainer = styled.div`
  margin: 16px 0;
`;

export const ExtraContent = styled.div`
  & > * {
    margin-top: 12px;
  }
`;

const colorMap = new Map<any, any>([
  ['warning', '#CB7813'],
  ['error', '#FA5245'],
  ['success', '#007B88'],
]);
const mapVariantToColor = (variant: string) => {
  return colorMap.get(variant) || 'var(--color-smoke-70)';
};
export const ExtraContentText = styled.p<any>`
  font-size: 14px;
  color: ${(p) => mapVariantToColor(p.variant)};
  a {
    color: #fa5245;
    text-decoration: underline;
    font-weight: 700;
  }
`;

export const HelpText = styled.div`
  color: #fa5245;
  font-weight: 700;
  display: inline-flex;
  margin-left: 6px;
  cursor: pointer;
`;
